// Canonical language code → display name. Single source for language filters + columns so a dropdown
// never shows a raw code like "en"/"mr". Codes match the app's languagePref values.
export const LANGUAGE_NAME: Record<string, string> = {
  en: 'English', hi: 'Hindi', mr: 'Marathi', bn: 'Bengali', or: 'Odia',
  ta: 'Tamil', te: 'Telugu', gu: 'Gujarati', kn: 'Kannada', pa: 'Punjabi',
};

/** code → display name (falls back to the upper-cased code for anything unmapped). */
export const languageName = (code?: string | null): string =>
  code ? (LANGUAGE_NAME[code] ?? code.toUpperCase()) : '';
